<template>
	<div  class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="goBack()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>2</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 2 - Abonneren</v-list-tile-title>
						<v-list-tile-sub-title>Welk abonnement wil je afsluiten?</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-container class="item-group" v-if="loaded">
				<v-alert
					:value="paymentFailed"
					type="error"
					outline
					class="mb-4"
				>
					Betaling niet gelukt.
				</v-alert>

				<p class="text--lighten-1 text-sm-center px-5 pb-2">
					<a href="https://e-finder.com" target="_blank" class="text--black">Kijk voor meer informatie over de abonmenten op onze website.</a>
				</p>

				<form @submit.prevent="submit">
					<v-radio-group v-model="selectedProductId" class="my-0 py-0">
						<v-list three-line class="mb-0 py-0">
							<v-list-tile avatar v-for="product in products" :key="product.key" class="mb-2 product-tile" :class="{'is-highlight': product.key == 'basic'}" @click="selectedProductId = product.id">
								<v-list-tile-avatar style="text-align: center">
									<v-radio :value="product.id" class="ma-0" :ripple="false"></v-radio>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title class="font-weight-medium">
										{{ product.name }}
										<span v-if="product.key == 'basic'"> - </span>
										<small v-if="product.key == 'basic'" class="green--text">meest gekozen</small>
									</v-list-tile-title>
									<v-list-tile-sub-title v-html="product.description"></v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-flex class="text-xs-right">
										<strong>{{ (product.price / 12) * .01 | currency }}</strong><br/>
										<small>per maand</small>
									</v-flex>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
					</v-radio-group>

					<div align="center" class="mb-5">
						<h2>Totaal bedrag: {{ selectedProduct.price * 0.01 | currency }}</h2>
						<p class="mb-2 grey--text">Abonnementen worden per jaar vooraf betaald</p>
					</div>

					<v-btn type="submit" block dark depressed large color="primary">Verder</v-btn>
				</form>
			</v-container>
		</v-content>
	</div>
</template>

<script>
  import SubscriptionService from '../../../services/SubscriptionService';

  export default {
    computed: {
      products() {
        return this.$store.state.products.products;
      },
	  selectedProduct(){
        return this.products.find(product => product.id === this.selectedProductId);
	  }
    },
    data() {
      return {
        loaded: false,
        paymentFailed: false,
        code: this.$route.params.slug,
        selectedProductId: null,
        errorMessage: '',
        loading: false
      };
    },
    watch: {
      code(value) {
        this.$nextTick(() => {
          this.code = value.replace(/[^0-9A-Fa-f]+/gi, '')
            .toUpperCase();
        });
      }
    },
    methods: {
      goBack(fallback) {
        this.$router.push({ name: 'devices.register'});
      },
      async submit() {
        this.$router.push({ name: 'devices.subscribe', params: { slug: this.code, productId: this.selectedProduct.id }});
      },
      loadProducts() {
        this.$store.dispatch('products/loadProducts')
          .then(() => {
            // Select first product
            this.loaded = true;

            let product = null;
            if(product = this.products.find(product => product.key == 'basic')){
              this.selectedProductId = product.id;
			}else if (this.products[0]) {
              this.selectedProductId = this.products[0].id;
            }
          });
      }
    },
    created() {
      this.loadProducts();
    }
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd

	.product-tile
		background-color: #fff
		border: solid 1px #dedede
		border-radius: .5rem

		.v-list__tile__avatar
			margin-top: 0

	.product-tile.is-highlight
		border: solid 1px #4CAF50
		background-color: rgba(#E8F5E9, .5)
		transition: background-color .2s

		&:hover
			background-color: #E8F5E9

		&:hover > .v-list__tile.theme--light
			background-color: transparent


</style>
